import { type ReactNode } from "react";
import { getSafeUrl } from "@/utils/ShopifyHelpers";

export type RichTextNode = {
  type: string;
  children?: RichTextNode[];
  value?: string;
  url?: string;
  fields?: {
    url?: string;
  };
  data?: {
    url?: string;
  };
  listType?: string;
};

export function parseRichText(raw: string | null): RichTextNode | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function renderRichTextNode(
  node: RichTextNode | null,
  key?: number,
): ReactNode {
  if (!node) return null;

  switch (node.type) {
    case "root":
      return <>{node.children?.map(renderRichTextNode)}</>;
    case "paragraph":
      return <p key={key}>{node.children?.map(renderRichTextNode)}</p>;
    case "list":
      return node.listType === "ordered" ? (
        <ol key={key}>{node.children?.map(renderRichTextNode)}</ol>
      ) : (
        <ul key={key} className="list-none">
          {node.children?.map(renderRichTextNode)}
        </ul>
      );
    case "list-item":
      return <li key={key}>{node.children?.map(renderRichTextNode)}</li>;
    case "autolink":
    case "link": {
      const safeUrl = getSafeUrl(
        node.url ?? node.fields?.url ?? node.data?.url,
      );
      return safeUrl ? (
        <a
          key={key}
          href={safeUrl.href}
          target={safeUrl.isExternal ? "_blank" : undefined}
          rel={safeUrl.isExternal ? "noopener noreferrer" : undefined}
        >
          {node.children?.map(renderRichTextNode)}
        </a>
      ) : (
        <span key={key}>{node.children?.map(renderRichTextNode)}</span>
      );
    }
    case "text":
      return <span key={key}>{node.value}</span>;
    default:
      return null;
  }
}
